import { render, staticRenderFns } from "./widgetformitem.vue?vue&type=template&id=8a9f833a&scoped=true&"
import script from "./widgetformitem.vue?vue&type=script&lang=js&"
export * from "./widgetformitem.vue?vue&type=script&lang=js&"
import style0 from "./widgetformitem.vue?vue&type=style&index=0&id=8a9f833a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9f833a",
  null
  
)

export default component.exports